module.exports = __webpack_public_path__ + "media/images/icons/align-right-a2eb553f659b6dc9525f494b0936223f.svg";